module.exports = __webpack_public_path__ + "static/img/20240927_3.5a838d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240927_3.png
// module id = /YRb
// module chunks = 0